<template>
  <v-container ref="copyContainer" grid-list-xl fluid>
    <v-overlay :value="pageLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <template v-if="!pageLoading">
      <v-row class="mb-1">
        <v-col cols="12">
          <filter-hoover-stats
            :default-search-params="searchParams"
            :is-component-loading="isRequestingNow"
            @filtering="onFilter"
            @download-excel="onDownloadExcel"
          ></filter-hoover-stats>
        </v-col>
      </v-row>

      <div v-if="data" class="mb-4">
        <v-row>
          <v-col cols="12" v-for="month in Object.keys(data)" :key="month">
            <v-card>
              <v-card-title>{{ formatMonth(month) }}</v-card-title>
              <v-divider/>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                  <tr>
                    <th class="text-center">{{ $t('table.headers.day') }}</th>
                    <th class="text-center">{{ $t('table.headers.client_phone') }}</th>
                    <th class="text-center">{{ $t('table.headers.discount_in_percent') }}</th>
                    <th class="text-center">{{ $t('table.headers.discount_in_uah') }}</th>
                    <th class="text-center">{{ $t('table.headers.cleaning_type_with_discount') }}</th>
                    <th class="text-center">{{ $t('table.headers.manager') }}</th>
                    <th class="text-center">{{ $t('table.headers.discount_reason') }}</th>
                    <th class="text-center">{{ $t('table.headers.status') }}</th>
                    <th class="text-center">{{ $t('table.headers.comment') }}</th>
                  </tr>
                  </thead>
                  <tbody class="font-size-table">
                  <tr v-for="(item,index) in data[month]" :key="index + '-' + item.day">
                    <td>{{ item.day }}</td>
                    <td>{{ item.client_phone }}</td>
                    <td class="text-center">{{ !item.is_money ? item.value : '' }}</td>
                    <td class="text-center">{{ item.is_money ? item.value : '' }}</td>
                    <td>{{ lang($store, `sap/listings.discount_stats.discount_cleaning_type.${item.cleaning_type}`) }}</td>
                    <td>{{ item.manager_name }}</td>
                    <td>{{ lang($store, `sap/listings.global.filter.discount_reasons.${item.reason}`) }}</td>
                    <td>{{ lang($store, `sap/listings.discount_stats.discount_status.${item.status}`) }}</td>
                    <td>{{ item.note }}</td>
                  </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </template>
    <modal-loading :is-show="isTableLoading"></modal-loading>
  </v-container>
</template>

<script>

import { deepMerge } from '@/utils';

import moment from 'moment';
/* constants */
import downloadReport from '@/mixins/reports/downloadReport';
import StatsProxy from '@/proxies/Stats/StatsDiscountProxy';
/* mixins */
import defaultListingMixin from '../../mixins/listing/defaultListingMixin';
import updatePageContentMixin from '../../mixins/updatePageContentMixin';

/* components */
import ModalLoading from '../../components/loaders/ModalLoading.vue';
import FilterHooverStats from '../../components/listings/FilterHooverStats.vue';

export default {
  name: 'DiscountStats',
  mixins: [updatePageContentMixin, defaultListingMixin, downloadReport],
  components: {
    ModalLoading,
    FilterHooverStats,
  },
  props: {
    defaultSearchParams: {
      type: Object,
      default: () => ({
        search_contact: '',
        search_cleaner: '',
      }),
    },
  },
  data() {
    return {
      /* Page management */
      pageLoading: false,
      /* Listing management */
      isTableLoading: false,
      searchParams: {
        from: null,
        to: null,
        region: null,
        period: null,
      },
      data: null,
      reportMethodName: 'discountsListingReport',
    };
  },
  computed: {
    /* store */
    account() {
      return this.$store.getters['account/account'];
    },
  },
  methods: {
    onFilter(event) {
      const newSearchParams = Object.assign({}, event);

      const oldSearchParams = Object.assign({}, this.searchParams);
      ['from', 'to', 'region', 'period'].forEach((element) => {
        if (!(element in oldSearchParams)) {
          oldSearchParams[element] = null;
        }
      });

      this.searchParams = deepMerge(oldSearchParams, deepMerge(newSearchParams, {
        page: {
          number: 1,
        },
      }));
    },

    fetchData() {
      new StatsProxy(this.searchParams)
        .list()
        .then(({ data: { data } }) => {
          this.data = data;
        })
        .catch(error => {
          this.data = null;
          console.error(error);
        })
        .finally(() => {
          this.isTableLoading = false;
          this.isRequestingNow = false;
          this.$store.dispatch('page/finishUpdateCurrentPageContent');
        });
    },
    formatMonth(month) {
      moment.locale(window.localStorage.language);
      const date = moment(month);
      return date.format('MMMM, YYYY');
    },
  },
};
</script>

<style>
.v-data-table > .v-data-table__wrapper > table > tbody.font-size-table > tr > td {
  font-size: 0.85rem;
}
</style>
